import React, { ReactElement } from 'react';
import {
  Box,
  createStyles,
  FormControl,
  FormHelperText,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import IconInfo from '~/images/icon-info.svg';
import { Tooltip } from '../Tooltip';

const useStyles = makeStyles(() =>
  createStyles({
    questionSectionHeadline: {
      fontSize: '1.5rem',
      letterSpacing: 0,
      fontFamily: 'BundesSans, sans-serif',
      lineHeight: '32px',
      margin: '1rem 0',
    },
    questionSubSectionHeadline: {
      fontSize: '1rem',
      fontFamily: 'BundesSans, sans-serif',
      lineHeight: '22px',
      margin: '1rem 0',
    },
    formTextLabel: {
      fontSize: '1rem',
      fontFamily: 'BundesSans, sans-serif',
      maxWidth: 300,
    },
    formWrapperWithInfo: {
      width: 300,
      display: 'flex',
      flexDirection: 'row',
    },
  })
);

export const InputField: React.FC<{
  error?;
  tooltipText?: string;
  unit?: string;
  helperText?: string;
}> = ({ error, tooltipText, children, unit, helperText }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={7}>
      <FormControl className={classes.formWrapperWithInfo}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            {children}{' '}
            <Typography variant="body2" style={{ fontSize: 16 }}>
              {unit}
            </Typography>
          </Box>
          {helperText && <Box style={{ color: '#939697' }}>{helperText}</Box>}
        </Box>
        {tooltipText && (
          <Box style={{ marginLeft: 20 }}>
            <Tooltip title={tooltipText}>
              <IconInfo />
            </Tooltip>
          </Box>
        )}
      </FormControl>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Grid>
  );
};

export const InputFieldLabel: React.FC<{
  formLabel: string;
  linkComponent?: ReactElement;
}> = ({ formLabel, linkComponent }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={5} className={classes.formTextLabel}>
      {formLabel}
      <br />
      {linkComponent}
    </Grid>
  );
};

export const SectionHeadline: React.FC<{
  headline: string;
}> = ({ headline }) => {
  const classes = useStyles();

  return (
    <Typography component="h3" className={classes.questionSectionHeadline}>
      {headline}
    </Typography>
  );
};

export const SubSectionHeadline: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Typography
      component="h4"
      variant="h4"
      style={{ marginBottom: 30 }}
      className={classes.questionSubSectionHeadline}
    >
      {children}
    </Typography>
  );
};
